import React from 'react'
import { I18n } from '@front/volcanion'

import { Box, Typography, Button } from '@mui/material'

const ImportForm = ({ file_name, importFile, onSubmit }) =>
  <Box sx={{ borderRadius: 1, boxShadow: 6, p: 1 }}>
    {!!file_name &&
      <Box mt={1}>
        <Typography fontSize={'subtitle.fontSize'} color='text.label' fontWeight={700}> {I18n.t('import.file', { name: file_name })}</Typography>
      </Box>
    }
    <Box sx={{ display: 'flex', justifyContent: 'center', gap: 1 }}>
      <Button color='primary' component='label'>
        {I18n.t('action.import')}
        <input
          onChange={importFile}
          accept='.csv,text/csv,text/plain'
          type='file'
          hidden
        />
      </Button>
      {!!file_name &&
        <Button color='primary' variant='contained' onClick={onSubmit}>
          {I18n.t('action.send')}
        </Button>
      }
    </Box>
  </Box>

export default React.memo(ImportForm)
